module.exports = __webpack_public_path__ + "static/media/faq-5.cceb1b3d.png";